/* 🤖 this file was generated by svg-to-ts */
export const siriusSmalldotsThreeVertical: {
  name: 'smalldots_three_vertical';
  data: string;
} = {
  name: 'smalldots_three_vertical',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM12 6.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM12 21.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" fill="currentColor"/></svg>`
};
